export default __webpack_public_path__ + "static/media/icon-video-2.ad0a33e4.svg";